import React from 'react';
import styles from './CardPermits.module.scss';
import ColItem from '../ColItem/ColItem';
import moment from 'moment';
import { permitConstants } from '../../../../../../constants/permit.constants';

const CardPermits = ({ permit }) => {
  return (
    <div className={styles.root} key={permit.id}>
      <ColItem label="Тип" text={permit?.permitType?.name} />
      <ColItem label="Статус" text={permit?.permitStatus?.name} />
      <ColItem
        label="Клиент-заявитель"
        text={permit?.clientFio || permit?.name || ''}
      />
      <ColItem
        label="Адрес"
        text={`${permit?.houseName}, кв. ${permit?.addressName}`}
      />
      <ColItem
        label="Дата окончания"
        text={
          permit?.permitType?.id === permitConstants.PERMANENT_PASS
            ? 'Бессрочный'
            : moment(permit?.expireDate).format(
                permitConstants.TEMPORARY_PASS
                  ? 'DD.MM.YYYY'
                  : 'DD.MM.YYYY HH:MM'
              )
        }
      />
    </div>
  );
};

export default CardPermits;
